import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../../components/Hero';
import CallToAction from '../../components/CallToAction';
import './ProjectPages.css';

// Import images
import kurumHeroImage from '../../assets/images/kurum.jpg';

const CorporateSoftware = () => {
  return (
    <div className="project-page corporate-software">
      <Helmet>
        <title>Eğitim Kurumları ve Yayınevleri İçin Yazılım Çözümleri | ProgenX 2026</title>
        <meta name="description" content="ProgenX eğitim kurumları ve yayınevleri için özel yazılım çözümleri. Standartlara uygun eğitim içerikleri, interaktif öğrenme materyalleri, akıllı tahta uygulamaları ve kurumsal yönetim sistemleri. Eğitim süreçlerini dijitalleştirin." />
        <meta name="keywords" content="eğitim yazılımı, yayınevi çözümleri, akıllı tahta uygulamaları, eğitim teknolojileri, kurumsal yazılım, interaktif içerik, eğitim kurumu yazılımı, dijital eğitim içeriği" />
        <meta property="og:title" content="Eğitim Kurumları İçin Yazılım Çözümleri | ProgenX" />
        <meta property="og:description" content="Eğitim kurumları ve yayınevleri için özel yazılım çözümleri ile eğitim süreçlerini dijitalleştirin." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenx.com.tr/projeler/kurumsal-yazilim" />
        <link rel="canonical" href="https://progenx.com.tr/projeler/kurumsal-yazilim" />
      </Helmet>

      <Hero 
        title="Kurumlara ve Yayınevlerine Yazılım Desteği" 
        backgroundImage={kurumHeroImage}
      />

      <div className="project-content">
        <div className="container">
          <section className="project-overview">
            <h2>Eğitim Kurumları ve Yayınevleri İçin Özel Çözümler</h2>
            <p>
              Eğitim kurumları ve yayınevleri için özel olarak tasarladığımız dijital çözümlerle, 
              eğitim süreçlerini daha verimli ve etkili hale getiriyoruz. Öğrencilerin daha iyi 
              öğrenmesi, öğretmenlerin daha kolay öğretmesi, yayınevlerinin içeriklerini daha 
              etkili sunması için teknolojiyi kullanıyoruz.
            </p>
          </section>

          <section className="features">
            <h2>Eğitim Kurumları ve Yayınevleri İçin Neler Yapıyoruz?</h2>
            <div className="features-grid">
              <div className="feature-item">
                <h3>Standartlara Uygun Eğitim İçerikleri</h3>
                <p>
                  Eğitim içeriklerinizi uluslararası standartlara uygun şekilde hazırlıyoruz. 
                  Bu sayede içerikleriniz her eğitim platformunda sorunsuz çalışır. Öğrencilerin 
                  ilerlemesini takip edebilir, detaylı raporlar alabilirsiniz.
                </p>
              </div>

              <div className="feature-item">
                <h3>Etkileşimli ve Eğlenceli Öğrenme Materyalleri</h3>
                <p>
                  Öğrencilerin dikkatini çeken, öğrenmeyi eğlenceli hale getiren interaktif 
                  içerikler hazırlıyoruz. Video, animasyon, ses gibi zengin medya içerikleri 
                  ile öğrenciler daha iyi öğrenir, öğretmenler daha kolay öğretir.
                </p>
              </div>

              <div className="feature-item">
                <h3>Sınıf İçi Etkileşimi Artıran Uygulamalar</h3>
                <p>
                  Akıllı tahtalar için özel uygulamalar geliştiriyoruz. Öğretmenler derslerini 
                  daha etkili anlatır, öğrenciler daha aktif katılır. Sınıf içi etkileşim artar, 
                  öğrenme kalitesi yükselir.
                </p>
              </div>

              <div className="feature-item">
                <h3>Kurumsal Yönetim Sistemleri</h3>
                <p>
                  Öğrenci bilgilerini, içerikleri, raporları tek bir yerden yönetmenizi sağlayan 
                  sistemler geliştiriyoruz. Mevcut sistemlerinizle entegre çalışır, işlerinizi 
                  kolaylaştırır.
                </p>
              </div>
            </div>
          </section>

          <section className="benefits">
            <h2>Eğitim Kurumları ve Yayınevleri İçin Ne Sağlıyoruz?</h2>
            <div className="benefits-grid">
              <div className="benefit-item">
                <h3>Daha Verimli Eğitim Süreçleri</h3>
                <p>Dijital içerikler ve otomatik sistemler sayesinde öğretmenler daha az zaman 
                harcayarak daha fazla iş yapar. Eğitim süreçleri hızlanır, kalite artar.</p>
              </div>

              <div className="benefit-item">
                <h3>Mevcut Sistemlerinizle Uyumlu</h3>
                <p>Yeni sistemlerimiz mevcut sistemlerinizle sorunsuz çalışır. Hiçbir şeyi 
                değiştirmeden, sadece ekleyerek işlerinizi kolaylaştırırız.</p>
              </div>

              <div className="benefit-item">
                <h3>Öğrenme Süreçlerini Takip Edin</h3>
                <p>Hangi öğrencinin ne kadar ilerlediğini, hangi konularda zorlandığını 
                detaylı raporlarla görürsünüz. Böylece öğrencilere daha iyi yardımcı olursunuz.</p>
              </div>

              <div className="benefit-item">
                <h3>Her Zaman Yanınızdayız</h3>
                <p>Sistemlerimiz hazır olduktan sonra da yanınızdayız. Sorunlarınızı çözer, 
                sistemlerinizi günceller, ihtiyacınız olduğunda destek oluruz.</p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <CallToAction 
        title="Eğitim Süreçlerinizi Dijitalleştirin"
        subtitle="Eğitim kurumları ve yayınevleri için özel çözümlerimizle tanışın."
        buttonText="İletişime Geçin"
        buttonLink="/iletisim"
      />
    </div>
  );
};

export default CorporateSoftware; 